'use strict';

require("core-js/modules/es6.regexp.replace");

module.exports = {
  processRequest: function processRequest(req) {
    req.url = req.url.replace(/[^%]+/g, function (s) {
      return encodeURI(s);
    });
  }
};